import request from './index'

// 获取批次列表
export function getList() {
  return request({
    url: '/user-batch',
    method: 'get'
  })
}

// 新增批次
export function save(data) {
  return request({
    url: '/user-batch/save',
    method: 'post',
    data
  })
}

// 获取批次详情（含成员列表）
export function getDetail(id) {
  return request({
    url: '/user-batch/' + id,
    method: 'get'
  })
}

// 更新批次
export function update(id, data) {
  return request({
    url: '/user-batch/update/' + id,
    method: 'post',
    data
  })
}

// 删除批次
export function deleteBatch(id) {
  return request({
    url: '/user-batch/delete/' + id,
    method: 'post'
  })
}

// 添加批次成员
export function addMember(data) {
  return request({
    url: '/user-batch/add-member',
    method: 'post',
    data
  })
}

// 移除批次成员
export function removeMember(batchId, userId) {
  return request({
    url: '/user-batch/' + batchId + '/member/' + userId,
    method: 'post'
  })
}
